<template>
  <div class="ept-container">
    <div class="hero">
      <span class="description">{{ itensCount }} itens encontrados com a palavra-chave:</span>
      <h1 class="title">“{{ tag.name }}”.</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "TagHero",

  props: {
    itensCount: {
      type: Number,
      required: true
    },

    tag: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~stylesheets/vars";

.hero {
  @apply w-full;
  border-left: 1px solid $blue-light;
  padding-left: 2rem;
  margin-top: 3.75rem;
  margin-bottom: 3.75rem;

  .description {
    display: block;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    color: $black;
    margin-bottom: 0.625rem;
  }

  .title {
    font-weight: bold;
    font-size: 36px;
    line-height: 41px;
    color: $black;
  }
}
</style>
